window.onload = function(){
    var collectionDescriptionToggle = document.querySelector('[data-collection-description-toggle]');
    var collectionDescription = document.querySelector('[data-top-collection-description]');
    var collectionDescriptionInner = document.querySelector('[data-top-collection-description-inner]');

    if (collectionDescriptionToggle && collectionDescription && collectionDescriptionInner) {
        collectionDescriptionToggle.addEventListener('click', function() {
            if (collectionDescription.classList.contains('expanded')) {
                collectionDescription.classList.remove('expanded');
                collectionDescriptionToggle.innerHTML = collectionDescriptionToggle.getAttribute('data-see-more');
            } else {
                collectionDescription.classList.add('expanded');
                collectionDescriptionToggle.innerHTML = collectionDescriptionToggle.getAttribute('data-see-less');
            }
        })
    } 
}